import script from "./index-error.vue?vue&type=script&lang=ts&setup=true"
export * from "./index-error.vue?vue&type=script&lang=ts&setup=true"

import "./index-error.vue?vue&type=style&index=0&id=9c54a484&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c54a484"]])

export default __exports__